(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/team-names.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/team-names.js');
"use strict";


const {
  useGetParticipantsByEvent
} = svs.components.tipsen.hooks;
const {
  ParticipantsNames
} = svs.components.lbUi.participants;
const TeamNames = _ref => {
  let {
    productId,
    drawNumber,
    drawEventNumber,
    nameSize,
    subDescription
  } = _ref;
  const [homeParticipant, awayParticipant] = useGetParticipantsByEvent(productId, drawNumber, drawEventNumber);
  return React.createElement(ParticipantsNames, {
    awayParticipant: awayParticipant,
    homeParticipant: homeParticipant,
    nameSize: nameSize,
    subDescription: subDescription
  });
};
setGlobal('svs.components.tipsen.couponStatic.TeamNames', TeamNames);

 })(window);